import { type Pathnames, defineRouting } from 'next-intl/routing'

import { DEFAULT_LOCALE, LOCALES } from '../constants'

const defaultRoutingConfig = defineRouting({
  // If this locale is matched, pathnames work without a prefix (e.g. `/about`).
  defaultLocale: DEFAULT_LOCALE,
  localeDetection: false,
  localePrefix: 'as-needed',
  // The list of all supported locales.
  locales: LOCALES,
  pathnames: {},
})

export default defaultRoutingConfig

export function routing(pathnames: Pathnames<typeof LOCALES>) {
  return {
    ...defaultRoutingConfig,
    pathnames: {
      ...defaultRoutingConfig.pathnames,
      ...pathnames,
    },
  }
}
